import { CachedPOSTRequest } from '../../classes/cached-request';

export type RequestQueueState = {
    requests: CachedPOSTRequest[];
};

export const initialRequestQueueState: RequestQueueState = {
    requests: [],
};
